if (!customElements.get('cart-discount')) {
  class CartDiscount extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.input = this.querySelector('input');
      this.button = this.querySelector('button');
      if (!this.input || !this.button) return;
      this.initialized = true;
      this.message = document.createElement('p');
      this.message.className = 'nl-cart-discount-message notranslate';
      this.message.setAttribute('translate', 'no');
      this.message.setAttribute('role', 'status');
      this.message.style.cssText = 'flex-basis:100%;margin:0;font-size:12px;line-height:1.5;text-align:left';
      // Keep drawer feedback below the input/button row.
      if (this.closest('.t4s-drawer__bottom')) {
        this.insertAdjacentElement('afterend', this.message);
      } else {
        this.append(this.message);
      }
      this.button.addEventListener('click', () => this.applyDiscountCode());
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.applyDiscountCode();
        }
      });
    }
    async applyDiscountCode() {
      const code = this.input.value.trim();
      if (this.button.disabled) return;
      if (!code) { this.input.focus(); return; }
      const messages = {"fr":["Ce code ne s’applique pas à ce panier.","Impossible de vérifier ce code. Veuillez réessayer."],"en":["This code does not apply to this cart.","Unable to check this code. Please try again."],"de":["Dieser Code gilt nicht für diesen Warenkorb.","Der Code konnte nicht geprüft werden. Bitte versuchen Sie es erneut."],"da":["Denne kode gælder ikke for denne kurv.","Koden kunne ikke kontrolleres. Prøv igen."],"es":["Este código no se aplica a este carrito.","No se ha podido comprobar el código. Inténtalo de nuevo."],"fi":["Tätä koodia ei voi käyttää tähän ostoskoriin.","Koodia ei voitu tarkistaa. Yritä uudelleen."],"hu":["Ez a kód nem alkalmazható erre a kosárra.","A kód ellenőrzése sikertelen. Kérjük, próbálja újra."],"it":["Questo codice non è applicabile al carrello.","Impossibile verificare il codice. Riprova."],"nl":["Deze code is niet geldig voor deze winkelwagen.","De code kon niet worden gecontroleerd. Probeer het opnieuw."],"pl":["Ten kod nie ma zastosowania do tego koszyka.","Nie można sprawdzić kodu. Spróbuj ponownie."],"pt":["Este código não se aplica a este carrinho.","Não foi possível verificar o código. Tente novamente."],"sv":["Den här koden gäller inte för den här varukorgen.","Koden kunde inte kontrolleras. Försök igen."]};
      const copy = messages[document.documentElement.lang.toLowerCase().split('-')[0]] || messages.en;
      this.message.textContent = '';
      this.button.disabled = true;
      this.button.classList.add('active');
      this.button.setAttribute('aria-busy', 'true');
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code })
        });
        if (!response.ok) throw new Error('Discount request failed');
        const cart = await response.json();
        const isMainCart = !!this.closest('.t4s-cartPage__form');
        await this.repaintCart(isMainCart);
        if (Array.isArray(cart.discount_codes) && cart.discount_codes.some(item => item.applicable === false)) {
          this.message.textContent = copy[0];
        } else {
          this.input.value = '';
        }
      } catch (error) {
        this.message.textContent = copy[1];
        console.error('Cart discount:', error);
      } finally {
        this.button.disabled = false;
        this.button.classList.remove('active');
        this.button.removeAttribute('aria-busy');
      }
    }
    async repaintCart(isMainCart) {
      const sectionId = isMainCart ? window.cartT4SectionID : 'mini_cart';
      if (!sectionId) throw new Error('Cart section unavailable');
      const url = new URL(location.href);
      url.searchParams.set('sections', sectionId);
      const response = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Cart refresh failed');
      const sections = await response.json();
      if (!sections[sectionId]) throw new Error('Cart section unavailable');
      const fresh = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      const current = isMainCart ? this.closest('.t4s-cartPage__form') : this.closest('#t4s-mini_cart') || this.closest('.shopify-section');
      if (!current) throw new Error('Cart container unavailable');
      const selectors = ['[data-cart-items]', '[data-cart-discounts]', '[data-cart-prices]'];
      const replacements = selectors.map(selector => ({
        target: current.querySelector(selector),
        source: fresh.querySelector(selector)
      }));
      if (replacements.some(item => !item.target || !item.source)) throw new Error('Incomplete cart section');
      replacements.forEach(({ target, source }) => { target.innerHTML = source.innerHTML; });
    }
  }
  customElements.define('cart-discount', CartDiscount);
}
